/**
 * Module-level access token store.
 *
 * The access token lives only in memory — it is never written to
 * localStorage, sessionStorage, or a JS-readable cookie.  Axios
 * interceptors read from here so the token is attached to every
 * authenticated request without touching React state.
 */

let _accessToken = null;

export const getAccessToken = () => _accessToken;

export const setAccessToken = (token) => {
  _accessToken = token;
};

export const clearAccessToken = () => {
  _accessToken = null;
};
